import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { getDefaultWorkspaceRoute } from 'helpers/workspace';

const ProtectedRoute = ({ children, isAuthenticated, requiredPermission, requiredAnyPermissions, allowedModes, requireSuperAdmin }) => {
  const { hasPermission, hasAnyPermission, getCurrentWorkspaceMode, isSuperAdmin } = useAuth();
  const currentMode = getCurrentWorkspaceMode();

  if (!isAuthenticated) {
    return <Navigate to='/login' replace />;
  }

  if (!isSuperAdmin() && Array.isArray(allowedModes) && allowedModes.length && !allowedModes.includes(currentMode)) {
    return <Navigate to={getDefaultWorkspaceRoute(currentMode)} replace />;
  }

  if (requireSuperAdmin && !isSuperAdmin()) {
    return <Navigate to={getDefaultWorkspaceRoute(currentMode)} replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to={getDefaultWorkspaceRoute(currentMode)} replace />;
  }

  if (requiredAnyPermissions && !hasAnyPermission(requiredAnyPermissions)) {
    return <Navigate to={getDefaultWorkspaceRoute(currentMode)} replace />;
  }

  return isAuthenticated 
    ? children
    : <Navigate to='/login' replace />;
};
ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  isAuthenticated: PropTypes.bool,
  requiredPermission: PropTypes.string,
  requiredAnyPermissions: PropTypes.arrayOf(PropTypes.string),
  allowedModes: PropTypes.arrayOf(PropTypes.string),
  requireSuperAdmin: PropTypes.bool
};

export default ProtectedRoute;
